/* Created by Interactive 63 - https://interactive63.com */
/**
 * Ctrl + S (save project file), Ctrl + Shift + S (save as) and Ctrl + O (open project file). These work even while a text
 * field has focus, and replace the browser's own save and open dialogs.
 */
import type { ProjectSession } from './session';

/** Registers the shortcuts and returns a function that removes them. */
export function registerFileShortcuts(session: ProjectSession): () => void {
  /** Routes the key combinations to the session. */
  const onKeyDown = (event: KeyboardEvent): void => {
    if (!(event.ctrlKey || event.metaKey) || event.altKey) return;
    const key = event.key.toLowerCase();
    if (key === 's') {
      event.preventDefault();
      if (event.shiftKey) void session.promptSaveAs();
      else void session.saveProjectFile();
    } else if (key === 'o' && !event.shiftKey) {
      event.preventDefault();
      session.chooseProjectFile();
    }
  };
  document.addEventListener('keydown', onKeyDown);
  return () => {
    document.removeEventListener('keydown', onKeyDown);
  };
}
